// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3-84_","content":"GlobalSearch_content__SC6jo"};